//@flow
import {useEffect, useState} from 'react';
import {
  getTikTokIntegrationService,
  saveTikTokIntegrationService,
} from './promises';

import type {SaveTikTokIntegrationRequest} from './api';

import type {TikTokIntegration} from '../../../entities/tiktok-integration';
import {useToastActions} from '../../toast-alert/utils';

export function useTikTokIntegration() {
  const [loading, setLoading] = useState(false);
  const [integration, setIntegration] = useState<TikTokIntegration | null>(
    null
  );

  const {showToast} = useToastActions();

  useEffect(() => {
    setLoading(true);

    getTikTokIntegrationService()
      .then(response => {
        setIntegration(response);
      })
      .catch(error => {
        console.error('Error fetching TikTok integration:', error);
        showToast({
          type: 'danger',
          title: 'Error',
          message: 'No se pudo obtener la integración de TikTok.',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [showToast]);

  const saveTikTokIntegration = async (
    request: SaveTikTokIntegrationRequest
  ) => {
    setLoading(true);
    try {
      const response = await saveTikTokIntegrationService(request);
      setIntegration(response);
      showToast({
        type: 'success',
        title: 'Éxito',
        message: 'La integración de TikTok se ha guardado correctamente.',
      });
    } catch (error) {
      console.error('Error saving TikTok integration:', error);
      showToast({
        type: 'danger',
        title: 'Error',
        message: 'No se pudo guardar la integración de TikTok.',
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    integration,
    saveTikTokIntegration,
  };
}
